import { render, staticRenderFns } from "./aufgabe-attachment-flugeinkauf-table.vue?vue&type=template&id=4553a6b6"
import script from "./aufgabe-attachment-flugeinkauf-table.vue?vue&type=script&lang=js"
export * from "./aufgabe-attachment-flugeinkauf-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports